module.exports = "<router-outlet></router-outlet>\r\n<p-growl></p-growl>"


//////////////////
// WEBPACK FOOTER
// C:/WORK/Projects/ActNow_NG2/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main